export enum SearchCouponsActionTypes {
    REQUEST = '@@tariff/search-coupons/request',
    SUCCESS = '@@tariff/search-coupons/success',
    ERROR = '@@tariff/search-coupons/error'
}

export enum GetTrafficAreasActionTypes {
    REQUEST = '@@tariff/get-traffic-areas/request',
    SUCCESS = '@@tariff/get-traffic-areas/success',
    ERROR = '@@tariff/get-traffic-areas/error'
}

export enum GetTrafficAreasGeographyActionTypes {
    REQUEST = '@@tariff/get-traffic-areas-geography/request',
    SUCCESS = '@@tariff/get-traffic-areas-geography/success',
    ERROR = '@@tariff/get-traffic-areas-geography/error'
}
